import React from 'react';
import './Cali.css';

const Cali = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
      <h1><a className='Titulo' href="/aip/SKCL.pdf" target="_blank" rel="noreferrer">Aeropuerto Internacional Alfonso Bonilla Aragón</a></h1>
    </div>
    
    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 02</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/SID/KIKU5A.pdf" target="_blank" rel="noreferrer">KIKU5A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/SID/BUN3C.pdf" target="_blank" rel="noreferrer">SIGI6C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/SID/BUN3C.pdf" target="_blank" rel="noreferrer">BUN3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/SID/CLO1C.pdf" target="_blank" rel="noreferrer">CLO1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/SID/CLO1D.pdf" target="_blank" rel="noreferrer">CLO1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/SID/ULQ1B.pdf" target="_blank" rel="noreferrer">ULQ1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/SID/MONV1A.pdf" target="_blank" rel="noreferrer">MONV1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/SID/MONV1A.pdf" target="_blank" rel="noreferrer">MONV1B</a></th>
          </tr> 

          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/SID/TOLI1F.pdf" target="_blank" rel="noreferrer">TOLI1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/SID/TOLI1F.pdf" target="_blank" rel="noreferrer">ULQ1K</a></th>
          </tr>

          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 20</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/SID/KIKU5A.pdf" target="_blank" rel="noreferrer">KIKU5B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/SID/PPN8B.pdf" target="_blank" rel="noreferrer">PPN8B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/SID/PPN8B.pdf" target="_blank" rel="noreferrer">ISOP4B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/SID/ULQ1B.pdf" target="_blank" rel="noreferrer">ULQ1C</a></th>
          </tr>
                   
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 02</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/MANG1B.pdf" target="_blank" rel="noreferrer">MANGA1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/OREG5A.pdf" target="_blank" rel="noreferrer">OREG5A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ASIK1C.pdf" target="_blank" rel="noreferrer">OREG2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ULQ7D.pdf" target="_blank" rel="noreferrer">ULQ7D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ASIK1C.pdf" target="_blank" rel="noreferrer">ULQ2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/OREG5A.pdf" target="_blank" rel="noreferrer">ULQ4E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/DAKO8A.pdf" target="_blank" rel="noreferrer">DAKO8A</a></th>
          </tr>          
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ANKA3A.pdf" target="_blank" rel="noreferrer">DAKO3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ANKA3A.pdf" target="_blank" rel="noreferrer">PPN3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ASIK3B.pdf" target="_blank" rel="noreferrer">DAKO3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ESAR1A.pdf" target="_blank" rel="noreferrer">ESAR1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ESAR1A.pdf" target="_blank" rel="noreferrer">DADV1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ESAR1A.pdf" target="_blank" rel="noreferrer">ILKU1A</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ESAR1A.pdf" target="_blank" rel="noreferrer">ISAD3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ASIK1C.pdf" target="_blank" rel="noreferrer">ASIK1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ASIK1C.pdf" target="_blank" rel="noreferrer">BUN1F</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ANKA3A.pdf" target="_blank" rel="noreferrer">ANKA3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ISOP4A.pdf" target="_blank" rel="noreferrer">ISOP4A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ASIK1C.pdf" target="_blank" rel="noreferrer">KIKU1D</a></th>
          </tr> 
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 20</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ULQ2A.pdf" target="_blank" rel="noreferrer">ULQ2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ETAL3A.pdf" target="_blank" rel="noreferrer">ULQ4F </a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ETAL3A.pdf" target="_blank" rel="noreferrer">KIKU3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ETAL3A.pdf" target="_blank" rel="noreferrer">SIPA3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ETAL3A.pdf" target="_blank" rel="noreferrer">ETAL3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ASIK3B.pdf" target="_blank" rel="noreferrer">ASIK3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ASIK3B.pdf" target="_blank" rel="noreferrer">BUN4E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ASIK3B.pdf" target="_blank" rel="noreferrer">BURP3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ASIK3B.pdf" target="_blank" rel="noreferrer">DAKO3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/STAR/ASIK3B.pdf" target="_blank" rel="noreferrer">ISKU3A</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 02</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/IAC/ILS Z.pdf" target="_blank" rel="noreferrer">ILS Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/IAC/ILS Y.pdf" target="_blank" rel="noreferrer">ILS Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/IAC/LOC.pdf" target="_blank" rel="noreferrer">LOC</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/IAC/VOR 02.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/IAC/RNP 02.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
         
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 20</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/IAC/VOR 20.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/IAC/RNP Z.pdf" target="_blank" rel="noreferrer">RNP Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/Procedimientos/IAC/RNP Y.pdf" target="_blank" rel="noreferrer">RNP Y</a></th>
          </tr>
          
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};


export default Cali;
